import { render, staticRenderFns } from "./CompanyStatisticsPieChart.vue?vue&type=template&id=827dc2b4&"
import script from "./CompanyStatisticsPieChart.vue?vue&type=script&lang=js&"
export * from "./CompanyStatisticsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CompanyStatisticsPieChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('827dc2b4')) {
      api.createRecord('827dc2b4', component.options)
    } else {
      api.reload('827dc2b4', component.options)
    }
    module.hot.accept("./CompanyStatisticsPieChart.vue?vue&type=template&id=827dc2b4&", function () {
      api.rerender('827dc2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/CompanyStatisticsPieChart.vue"
export default component.exports